module.exports = __webpack_public_path__ + "static/media/42-4.cc91496d.mp3";